import * as PIXI from "pixi.js";

export default class AnimatedSprite extends PIXI.Sprite {

    public animationSpeed: number = 1;
    public loop: boolean = true;
    public onComplete: Function = null;
    public onFrameChange: Function = null;
    public playing: boolean = false;
    public currentFrame: number = 0;

    public destroyed: boolean = false;

    private textures: PIXI.Texture[];
    private deltaTime: number = 0;
    private lastTime: number = null;

    constructor(textures: PIXI.Texture[]) {
        super(textures[0]);

        this.currentFrame = 0;
        this.textures = textures;
    }

    public stop() {
        this.playing = false;
    }

    public play() {
        this.playing = true;
    }

    public gotoAndStop(frame: number) {
        this.currentFrame = frame;
        this.stop();
        this.updateTexture();

    }

    public gotoAndPlay(frame: number) {
        this.currentFrame = frame;
        this.play();
        this.updateTexture();
    }

    public update(time: number) {

        if (this.lastTime === null) {
            this.lastTime = time;
        }

        if (this.playing) {
            this.deltaTime += time - this.lastTime;

            const timePerFrame = (1000 / 60) / this.animationSpeed;

            while (this.deltaTime > timePerFrame) {

                this.deltaTime -= timePerFrame;
                this.currentFrame++;

                if (this.currentFrame >= this.textures.length) {
                    if (this.loop) {
                        this.currentFrame = 0;
                    } else {
                        this.currentFrame = this.textures.length - 1;
                        this.stop();
                    }

                    if (this.onComplete) {
                        this.onComplete();
                        break;
                    }
                }
            }
        } else {
            this.deltaTime = 0;
        }

        this.lastTime = time;

        const textureChanged = this.updateTexture();

        if (textureChanged && this.onFrameChange) {
            this.onFrameChange(this.currentFrame);
        }
    }

    public updateTexture() {
        if (this.texture !== this.textures[this.currentFrame]) {
            this.texture = this.textures[this.currentFrame];
            // this._textureID = -1;

            return true;
        }

        return false;
    }

    public destroy() {
        this.destroyed = true;
        this.stop();
        super.destroy();
    }

    get totalFrames() {
        return this.textures.length;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/graphics/animation/animated-sprite.ts